import { render, staticRenderFns } from "./addPunishJobDialog.vue?vue&type=template&id=de524e04&scoped=true"
import script from "./addPunishJobDialog.vue?vue&type=script&lang=js"
export * from "./addPunishJobDialog.vue?vue&type=script&lang=js"
import style0 from "./addPunishJobDialog.vue?vue&type=style&index=0&id=de524e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de524e04",
  null
  
)

export default component.exports